<template>
  <div>
      <home></home>
      <shuomin></shuomin>
      <wulian></wulian>
      <dails></dails>
  </div>
</template>

<script>
// 首页
import home from './componets/home.vue'
import shuomin from './componets/shuomin.vue'
import wulian from './componets/wulian.vue'
import dails from './componets/dails.vue'
export default {
  components:{
    home,
    shuomin,
    wulian,
    dails
  },
  mounted(){
    window.scrollTo(100,0);
  }
}
</script>

<style>

</style>